<!-- src/components/Layout/FooterComponent.vue -->
<template>
  <footer class="site-footer">
    <div class="relative mx-auto max-w-screen-2xl px-4 sm:px-6 lg:px-8">
      <ul
        class="grid grid-cols-2 items-center justify-center gap-2 text-sm font-medium sm:flex sm:flex-row"
      >
        <li>
          <RouterLink
            to="/about-us"
            class="transition-colors hover:text-blue-600"
            :class="{ 'font-semibold text-blue-600': isActive('/about-us') }"
          >
            About Us
          </RouterLink>
        </li>
        <li>
          <RouterLink
            to="/contact-us"
            class="transition-colors hover:text-blue-600"
            :class="{ 'font-semibold text-blue-600': isActive('/contact-us') }"
          >
            Contact Us
          </RouterLink>
        </li>
        <li>
          <RouterLink
            to="/portal/privacy"
            class="transition-colors hover:text-blue-600"
            :class="{ 'font-semibold text-blue-600': isActive('/portal/privacy') }"
          >
            Privacy Policy
          </RouterLink>
        </li>
        <li>
          <RouterLink
            to="/portal/terms"
            class="transition-colors hover:text-blue-600"
            :class="{ 'font-semibold text-blue-600': isActive('/portal/terms') }"
          >
            Terms of Service
          </RouterLink>
        </li>
      </ul>

      <!-- Lower-right floating bug-report button (positioned inside the
           footer so it sits below the SiteChat communications launcher). -->
      <div class="absolute right-2 top-1/2 -translate-y-1/2 sm:right-3 lg:right-4">
        <QuickBugButton />
      </div>
    </div>
  </footer>
</template>

<script setup>
import { useRoute } from 'vue-router'
import QuickBugButton from '@/components/Layout/QuickBugButton.vue'
const route = useRoute()
const isActive = path => route.path === path
</script>
